import vmClient from 'app/services/vmClient';
import { Text, IText } from 'app/constants/schemas/Text';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IAnswer extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string | null;
    correct: boolean | null;
  };
  associations: {
    text: IText;
  };
}

export type Answer = Entity<IAnswer>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Answer: IEntityType<IAnswer> = vmClient.defineClass({
  typeName: 'Answer',
  version: 2,
  lockable: true,
  persisted: true,
  attributes: {
    cohortId: 'string',
    correct: 'boolean',
  },
  associations: {
    text: {
      type: Text,
      notNull: true,
    },
  },
});
